import { IBazzarvoiceWidgetData } from './bazzarvoice-widget.data';
import { IBazzarvoiceWidgetProps } from './bazzarvoice-widget.props.autogenerated';

export interface IBazzarvoiceWidgetViewProps extends IBazzarvoiceWidgetProps<IBazzarvoiceWidgetData> {}

/**
 *
 * BazzarvoiceWidget component
 * @extends {React.PureComponent<IBazzarvoiceWidgetProps<IBazzarvoiceWidgetData>>}
 */
const BazzarvoiceWidget = (props: IBazzarvoiceWidgetProps<IBazzarvoiceWidgetData>) => {
    return props.renderView(props);
};

export default BazzarvoiceWidget;
